
const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Across Indent Material Upload Header',
  description: 'Material upload across indents using single file can be acheived using this config. Shippment unmapped report is aligned with this format',
  sortOrder: 1,
  name: 'acrossIndentMaterialUploadHeader',
  documentKey: 'across_indent_material_upload_header',
  values: {
    'Indent Number': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'indent_no',
      displayName: 'Indent Number',
      documentKey: 'Indent Number',
    },
    'Shipment No': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'material_ref_id',
      displayName: 'Shipment No',
      documentKey: 'Shipment No',
    },
    'Material Code': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'material_code',
      displayName: 'Material Code',
      documentKey: 'Material Code',
    },
    Quantity: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'quantity',
      displayName: 'Quantity',
      documentKey: 'Quantity',
    },
    'Quantity Unit': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'quantity_unit',
      displayName: 'Quantity Unit',
      documentKey: 'Quantity Unit',
    },
    'Total Weight': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'weight',
      displayName: 'weight_unit',
      documentKey: 'Total Weight',
    },
    'Weight Unit': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'weight_unit',
      displayName: 'Weight Unit',
      documentKey: 'Weight Unit',
    },
    Volume: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'volume',
      displayName: 'Volume',
      documentKey: 'Volume',
    },
    'Volume Unit': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'volume_unit',
      displayName: 'Volume Unit',
      documentKey: 'Volume Unit',
    },
    Pickup: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'pickup_point',
      displayName: 'Pickup',
      documentKey: 'Pickup',
    },
    'Ship To': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'ship_to',
      displayName: 'Ship To',
      documentKey: 'Ship To',
    },
    'Sold To': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'sold_to',
      displayName: 'Sold To',
      documentKey: 'Sold To',
    },
    'Invoice Number': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'invoice_number',
      displayName: 'Invoice Number',
      documentKey: 'Invoice Number',
    },
    'Invoice Date': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'invoice_date',
      displayName: 'Invoice Date',
      documentKey: 'Invoice Date',
    },
    'Invoice Amount': {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'invoice_amount',
      displayName: 'Invoice Amount',
      documentKey: 'Invoice Amount',
    },
    Category: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'category',
      displayName: 'Category',
      documentKey: 'Category',
    },
    MRP: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'mrp',
      displayName: 'MRP',
      documentKey: 'MRP',
    },
  },
};
